import { useSelector } from 'react-redux';
import { editExperienceSelector } from '../../Profile/CandidateDetails.selector';
import { ExperienceEditType } from 'app/models/Candidate/CandidateProfile';
import EditWorkExperienceDialogue from './EditWorkExperienceDialogue';
import React, { useEffect, useState } from 'react';
import { EditTimeOffDialog } from './EditTimeOffDialog';

export const EditExperienceWrapper = () => {
  const editExperience = useSelector(editExperienceSelector);

  return editExperience.type == ExperienceEditType.WorkExperience ? (
    <EditWorkExperienceDialogue />
  ) : (
    <EditTimeOffDialog />
  );
};
